export const initialState = {
  automaticUserAllocationsGroupedByDealer: [],
  deletedAutomaticUserAllocationIds: [],
  loaded: false
};

export const reducer = (state, action) => {
  switch (action.type) {
    case 'OnInitState':
      return onInitState(state, action);
    case 'OnSaveSuccesful':
      return onSaveSuccesful(state, action);
    case 'OnAddCard':
      return onAddCard(state);
    case 'OnAddAllocation':
      return onAddAllocation(state, action);
    case 'OnDeleteCard':
      return onDeleteCard(state, action);
    case 'OnDeleteAllocation':
      return onDeleteAllocation(state, action);
    case 'OnPropertyChange':
      return onPropertyChange(state, action);

    default:
      return state;
  }
};

const onInitState = (state, action) => {
  const { automaticUserAllocations } = action;

  let automaticUserAllocationsGroupedByDealer = new Set();
  automaticUserAllocations.forEach(item => automaticUserAllocationsGroupedByDealer.add(item.dealerId));
  automaticUserAllocationsGroupedByDealer = [...automaticUserAllocationsGroupedByDealer].map(dealerId => {
    return {
      dealerId: dealerId,
      isDirty: false,
      allocations: automaticUserAllocations.filter(x => x.dealerId === dealerId)
    };
  });

  return {
    ...state,
    automaticUserAllocationsGroupedByDealer: automaticUserAllocationsGroupedByDealer,
    loaded: true
  };
};

const onSaveSuccesful = (state, action) => {
  const { automaticUserAllocations } = action;

  const dealerId = automaticUserAllocations[0].dealerId;

  const groupedAllocations = JSON.parse(JSON.stringify(state.automaticUserAllocationsGroupedByDealer));
  const cardToChange = groupedAllocations.find(x => x.dealerId === dealerId);

  let currentDealerAllocations = groupedAllocations.find(x => x.dealerId === dealerId);

  var automaticUserAllocationsAfterSave = automaticUserAllocations.map(a => {
    var currentAllocation = currentDealerAllocations.allocations.find(
      ca =>
        ca.automaticUserAllocationId === a.automaticUserAllocationId ||
        (ca.automaticUserAllocationId === null,
        ca.userId === a.userId &&
          ca.offerResponsibleId === a.offerResponsibleId &&
          ca.offerInsuranceUserId === a.offerInsuranceUserId &&
          ca.offerAccountManagerId === a.offerAccountManagerId)
    );
    if (currentAllocation)
      a = {
        ...a,
        dealerName: currentAllocation.dealerName,
        userName: currentAllocation.userName,
        offerResponsibleName: currentAllocation.offerResponsibleName,
        offerInsuranceUserName: currentAllocation.offerInsuranceUserName,
        offerAccountManagerName: currentAllocation.offerAccountManagerName
      };
    return a;
  });

  currentDealerAllocations.allocations = automaticUserAllocationsAfterSave;

  cardToChange.isDirty = false;

  return {
    ...state,
    automaticUserAllocationsGroupedByDealer: groupedAllocations,
    deletedAutomaticUserAllocationIds: []
  };
};

const onAddCard = state => {
  const groupedAllocations = Object.assign(state.automaticUserAllocationsGroupedByDealer);
  groupedAllocations.push({
    dealerId: null,
    isDirty: true,
    allocations: [
      {
        automaticUserAllocationId: null,
        dealerId: null,
        userId: null,
        offerResponsibleId: null,
        offerInsuranceUserId: null,
        offerAccountManagerId: null,
        allUsers: false
      }
    ]
  });

  return {
    ...state,
    automaticUserAllocationsGroupedByDealer: groupedAllocations
  };
};

const onDeleteCard = (state, action) => {
  const { cardIndex } = action;
  const groupedAllocations = Object.assign(state.automaticUserAllocationsGroupedByDealer);
  groupedAllocations.splice(cardIndex, 1);

  return {
    ...state,
    automaticUserAllocationsGroupedByDealer: groupedAllocations
  };
};

const onAddAllocation = (state, action) => {
  const { cardIndex } = action;
  const groupedAllocations = JSON.parse(JSON.stringify(state.automaticUserAllocationsGroupedByDealer));
  const cardToChange = groupedAllocations[cardIndex];
  cardToChange.allocations.push({
    automaticUserAllocationId: null,
    dealerId: cardToChange.dealerId,
    userId: null,
    offerResponsibleId: null,
    offerInsuranceUserId: null,
    offerAccountManagerId: null,
    allUsers: false
  });
  cardToChange.isDirty = true;

  return {
    ...state,
    automaticUserAllocationsGroupedByDealer: groupedAllocations
  };
};

const onDeleteAllocation = (state, action) => {
  const { cardIndex, allocationIndex } = action;
  const groupedAllocations = JSON.parse(JSON.stringify(state.automaticUserAllocationsGroupedByDealer));
  const cardToChange = groupedAllocations[cardIndex];
  const idToDelete = cardToChange.allocations[allocationIndex].automaticUserAllocationId;
  const deletedAutomaticUserAllocationIds = [...state.deletedAutomaticUserAllocationIds];

  if (idToDelete) deletedAutomaticUserAllocationIds.push(idToDelete);
  cardToChange.allocations.splice(allocationIndex, 1);
  cardToChange.isDirty = true;

  return {
    ...state,
    automaticUserAllocationsGroupedByDealer: groupedAllocations,
    deletedAutomaticUserAllocationIds: deletedAutomaticUserAllocationIds
  };
};

const onPropertyChange = (state, action) => {
  const { prop, value, cardIndex, allocationIndex, prop2, value2 } = action;

  const groupedAllocations = JSON.parse(JSON.stringify(state.automaticUserAllocationsGroupedByDealer));
  const cardToChange = groupedAllocations[cardIndex];
  if (prop === 'dealerId') {
    cardToChange.dealerId = value;
    cardToChange.allocations = [{ dealerId: value, dealerName: value2 }];
    cardToChange.isDirty = true;
    return {
      ...state,
      automaticUserAllocationsGroupedByDealer: groupedAllocations
    };
  }
  if (prop === 'allUsers' && value === true) {
    cardToChange.allocations = [cardToChange.allocations[0]];
    cardToChange.allocations[0].userId = null;
    cardToChange.allocations[0].userName = null;
    const allocationsToDelete = state.deletedAutomaticUserAllocationIds.concat(
      groupedAllocations[cardIndex].allocations.map(x => x.automaticUserAllocationId)
    );
    if (cardToChange.allocations[0].automaticUserAllocationId)
      allocationsToDelete.splice(
        allocationsToDelete.findIndex(x => x === cardToChange.allocations[0].automaticUserAllocationId),
        1
      );
  }

  const allocationToChange = cardToChange.allocations[allocationIndex];
  allocationToChange[prop] = value;
  if (prop2) allocationToChange[prop2] = value2;
  cardToChange.isDirty = true;

  return {
    ...state,
    automaticUserAllocationsGroupedByDealer: groupedAllocations
  };
};
